
import AppReminderTemplateEdit from "@/components/settings-default/ReminderEmailTemplateEdit.vue";
import { ReminderEmailTemplate } from "@/models/reminder-email-template";
import { ReminderService } from "@/services/reminder-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			template: new ReminderEmailTemplate()
		};
	},
	computed: {
		crumbs():IBreadCrumb[] {
			return [
				{
					to: "/settings", value: this.$ct("general").toString()
				},
				{
					to: "/settings/reminders",
					value: this.$ct("reminders").toString()
				},
				{
					value: this.$ct("email-template").toString()
				}
			];
		}
	},
	methods: {
		async save() {
			if (this.template.ID == 0) {
				[this.template] = await ReminderService.postEmailTemplates([this.template]);
			} else {
				[this.template] = await ReminderService.putEmailTemplates([this.template]);
			}
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
		}
	},
	async mounted() {
		let id = parseInt(this.$route.params.id || "0");
		if (id != 0) {
			this.template = await ReminderService.getEmailTemplate(id);
		}
	},
	components: {
		AppReminderTemplateEdit
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
